const en = {
  loading: 'Loading reports...',
  loadFailed: 'Failed to load reports',
  title: 'Reports',
  description: 'Carpools reported from the app. Ignore a report to keep the carpool, or delete the carpool.',
  empty: 'No reports to review.',
  created: 'Created',
  status: 'Status',
  reportedBy: 'Reported by',
  carpool: 'Carpool',
  offeredBy: 'Offered by',
  actions: 'Actions',
  direction: 'Direction:',
  departure: 'Departure:',
  name: 'Name:',
  phone: 'Phone:',
  /** The reported carpool's direction, from the API: to or from (the festival) */
  directionValue: (direction: string) => direction,
  /** A report's status, from the API: pending, ignored or processed */
  statusLabel: (status: string) => status,
  /** Ignoring a report keeps its carpool */
  ignore: {
    button: 'Ignore',
    title: 'Ignore Report',
    confirm: (userName: string) => `Are you sure you want to ignore this report for carpool from ${userName}?`,
    busy: 'Ignoring...',
    failed: 'Failed to ignore report',
  },
  /** Deleting from a report deletes the reported carpool */
  delete: {
    button: 'Delete',
    title: 'Delete Report',
    confirm: (userName: string) => `Are you sure you want to delete this carpool from ${userName}?`,
    busy: 'Deleting...',
    failed: 'Failed to delete report',
  },
};

const DIRECTION_VALUES: Record<string, string> = { to: 'vers le festival', from: 'depuis le festival' };

const STATUS_LABELS: Record<string, string> = { pending: 'nouveau', ignored: 'ignoré', processed: 'traité' };

const fr: typeof en = {
  loading: 'Chargement des signalements...',
  loadFailed: 'Impossible de charger les signalements',
  title: 'Signalements',
  description: "Covoiturages signalés depuis l'app. Ignorez un signalement pour garder le covoiturage, ou supprimez le covoiturage.",
  empty: 'Aucun signalement à traiter.',
  created: 'Créé le',
  status: 'Statut',
  reportedBy: 'Signalé par',
  carpool: 'Covoiturage',
  offeredBy: 'Proposé par',
  actions: 'Actions',
  direction: 'Sens\u00a0:',
  departure: 'Départ\u00a0:',
  name: 'Nom\u00a0:',
  phone: 'Téléphone\u00a0:',
  directionValue: direction => DIRECTION_VALUES[direction] ?? direction,
  statusLabel: status => STATUS_LABELS[status] ?? status,
  ignore: {
    button: 'Ignorer',
    title: 'Ignorer le signalement',
    confirm: userName =>
      `Voulez-vous vraiment ignorer ce signalement sur le covoiturage proposé par ${userName}\u00a0?`,
    busy: 'Traitement...',
    failed: "Impossible d'ignorer le signalement",
  },
  delete: {
    button: 'Supprimer',
    title: 'Supprimer le covoiturage',
    confirm: userName => `Voulez-vous vraiment supprimer ce covoiturage proposé par ${userName}\u00a0?`,
    busy: 'Suppression...',
    failed: 'Impossible de supprimer le covoiturage',
  },
};

const messages = { en, fr };
export default messages;
